import axios from 'axios'

export default class AbstractAxiosService {
  constructor (options = {}) {
    this.groupedRequests = []
    this.accumulatorUrl = ''
    this.accumulatorCancelGroups = []
    Object.assign(this, options)
  }

  makeRequest (method, url, ...args) {
    return this.makeRequestRaw(method, url, ...args)
      .then((response) => this.translateApi(response))
      .catch((err) => this.translateError(err))
  }

  makeRequestRaw (method, url, ...args) {
    const ep = this.endpoint ? this.endpoint : '' ;
    
    // append an api key
    method = method.toLowerCase()
    let opts = ['put', 'post', 'patch'].indexOf(method) >= 0 ? args[1] : args[0]
    let data = ['put', 'post', 'patch'].indexOf(method) >= 0 ? args[0] : null
    if (opts == null) {
      opts = {}
      args.push(opts)
    }
    opts.headers = opts.headers || {}

    if (this.endpointApiKey) {
      opts.headers.Authorization = `ApiKey ${this.endpointApiKey}`
    }
    let outUrl = url
    if (opts.path) {
      // replace path with slugs
      outUrl = outUrl.replace(/:([a-z-]+)?/g, (match, g1) => opts.path[g1] != null ? opts.path[g1] : '')
    }

    // old school form-encoded...
    if (opts.urlencoded) {
      opts.headers['content-type'] = 'application/x-www-form-urlencoded'
      opts.headers['access-control-allow-origin'] = '*'
      if (typeof data === 'object') {
        const params = new URLSearchParams()
        for (const [i, v] of Object.entries(data)) {
          params.append(i, v)
        }
        data = params.toString()
      }
    }

    if (this.mock) {
      return this.mock.request(method, url, ...args)
    } else if (opts.group && this.accumulatorUrl) {
      if (data) {
        args[0] = data
      }
      return this.groupRequest(opts.group, method, ep + outUrl, ...args)
    } else {
      if (data) {
        args[0] = data
      }
      return axios[method](ep + outUrl, ...args)
    }
  }

  groupRequest (group, method, url, ...args) {
    let buildUrl = url
    const hasBody = ['put', 'post', 'patch'].indexOf(method) >= 0
    const opts = hasBody ? args[1] : args[0]
    const body = hasBody ? args[0] : null

    if (opts.params) {
      buildUrl += '?' + Object.entries(opts.params)
        .map(([k, v]) => `${window.encodeURI(k)}=${window.encodeURI(v)}`)
        .join('&')
    }
    const req = {
      group,
      method,
      url: buildUrl,
      body,
      opts,
      args,
      resolve: null,
      reject: null,
      promise: null,
      state: 0
    }
    const prom = new Promise((resolve, reject) => {
      req.resolve = resolve
      req.reject = reject
    })
    req.promise = prom
    this.groupedRequests.push(req)

    setTimeout(() => this.executeGroupRequests(), 5)

    return prom
  }

  async executeGroupRequests () {
    const groupRequests = []
    const rndId = Math.random().toString()

    // HACK: this mechanic is currently not flawless because the original group is not always requested
    let firstGroup = null
    for (const req of this.groupedRequests) {
      if (req.groupId != null) continue

      firstGroup = firstGroup || req.group
      req.groupId = rndId
      req.groupIdx = groupRequests.length
      groupRequests.push({
        method: req.method.toUpperCase(),
        url: req.url,
        body: req.body
      })
    }

    if (groupRequests.length < 1) {
      // if there is nothing todo, escape
      return
    }

    let result = null
    try {
      const accumulatorUrl = this.accumulatorCancelGroups.includes(firstGroup)
        ? `${this.accumulatorUrl}?cancelOnFail=true`
        : this.accumulatorUrl

      result = await axios.post(accumulatorUrl, { requests: groupRequests })
    } catch (err) {
      result = err
    }
    const affectedRequets = this.groupedRequests.filter(v => v.groupId === rndId)
    for (const req of affectedRequets) {
      if (result.data != null && result.data.responses[req.groupIdx]) {
        const reqData = result.data.responses[req.groupIdx]
        if (reqData.statusCode >= 200 && reqData.statusCode <= 301) {
          req.resolve({
            statusCode: reqData.statusCode,
            data: reqData.content
          })
        } else {
          req.reject({
            response: {
              statusCode: reqData.statusCode,
              data: reqData.content
            }
          })
        }
      } else {
        req.reject({
          response: {
            statusCode: 500,
            data: {
              message: 'Accumulator Error'
            }
          }
        })
      }
    }
  }

  translateApi (response) {
    // {
    //   data: {},
    //   status: 200,
    //   statusText: 'OK',
    //   headers: {},
    //   config: {},
    //   request: {}
    // }

    // detect dataformat
    if (response.data == null && response.statusCode === 204) {
      return Promise.resolve(true)
    } else if (response.data.error) {
      // eslint-ignore
      return Promise.reject({ status: response.statusCode, code: response.data.errorCode, message: response.data.errorMessage, data: response.data }) // eslint-disable-line prefer-promise-reject-errors
    } else if (response.data.errors) {
      return Promise.reject({ status: response.statusCode, code: response.data.errorCode, message: 'validation', errors: response.data.errors }) // eslint-disable-line prefer-promise-reject-errors
    } else if (response.data.status != false) { // eslint-disable-line eqeqeq
      // TODO: the api is inconsistent in the response format
      return Promise.resolve(response.data.response || response.data)
    } else {
      return Promise.reject({ code: response.statusCode }) // eslint-disable-line prefer-promise-reject-errors
    }
  }

  translateError (err) {
    return Promise.reject(err)
  }
}
